import { FormWithRedux } from '../../FormWithRedux';
import React from 'react';

export class ACCBISTPupilAssessmentForm extends FormWithRedux {

    constructor(parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super('pupilAssessmentSubform', parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        return true;
    }

    isEnabled() {
        return true;
    }

    isMandatory(identifier) {
        let allFineCheck = this.getValue('neuroObsOkayCheck');
        
        if (allFineCheck != null && allFineCheck != undefined && allFineCheck == true) {
            return false;
        }

        return true;
    }

    getValueType(identifier) {

        if(identifier === 'leftPupilSize' || identifier === 'rightPupilSize') {
            return 'double';
        }
        else if (identifier === 'leftPupilReaction' || identifier === 'rightPupilReaction') {
            return 'string';
        }

        return null;
    }

    submissionValidation() {
        return [];
    }

    editingValidation(identifier) {
        return [];
    }

    detailForIdentifier(prefix, value) {
        if (value.identifier === 'leftPupilSize' && value.valueDescription() != null) {
            return prefix + 'Left Size: ' + value.valueDescription() + 'mm';
        }
        else if (value.identifier === 'rightPupilSize' && value.valueDescription() != null) {
            return prefix + 'Right Size: ' + value.valueDescription() + 'mm';
        }
        else if (value.identifier === 'leftPupilReaction' && value.valueDescription() != null) {
            return prefix + 'Left Reaction: ' + value.valueDescription();
        }
        else if (value.identifier === 'rightPupilReaction' && value.valueDescription() != null) {
            return prefix + 'Right Reaction: ' + value.valueDescription();
        }
        else {
            return super.detailForIdentifier(prefix, value);
        }
    }

    htmlForIdentifier(prefix, value) {
        if (value.identifier === 'leftPupilSize' && value.valueDescription() != null) {
            return (<div key={value.identifier} >
                <label className='list-detail'>{'Left Size: '} &#160;</label>
                <label className='list-detail'>{value.valueDescription()}mm</label>
            </div>);
        }
        else if (value.identifier === 'rightPupilSize' && value.valueDescription() != null) {
            return (<div key={value.identifier} >
                <label className='list-detail'>{'Right Size: '} &#160;</label>
                <label className='list-detail'>{value.valueDescription()}mm</label>
            </div>);
        }
        else if (value.identifier === 'leftPupilReaction' && value.valueDescription() != null) {
            return (<div key={value.identifier} >
                <label className='list-detail'>{'Left Reaction: '} &#160;</label>
                <label className='list-detail'>{value.valueDescription()}</label>
            </div>);
        }
        else if (value.identifier === 'rightPupilReaction' && value.valueDescription() != null) {
            return (<div key={value.identifier} >
                <label className='list-detail'>{'Right Reaction: '} &#160;</label>
                <label className='list-detail'>{value.valueDescription()}</label>
            </div>);
        }
        else {
            return super.htmlForIdentifier(prefix, value);
        }
    }
}


// WEBPACK FOOTER //
// ./src/forms/concussion01/Forms/ACCSBIST-PupilAssessmentForm.js